import { DateTime } from 'luxon';

function ResumenSensor({ datos, tipo }) {
  const hoy = DateTime.local().toFormat('yyyy-MM-dd');

  const valores = datos
    .filter(d => d.Tipo === tipo && d.FechaHora.startsWith(hoy))
    .map(d => ({ valor: d.Valor, hora: DateTime.fromISO(d.FechaHora).toFormat('HH:mm:ss') }));

  if (valores.length === 0) {
    return <p style={{ fontSize: '0.9rem', color: '#999' }}>Sin datos hoy</p>;
  }

  const actual = valores[valores.length - 1];
  const min = valores.reduce((a, b) => (a.valor < b.valor ? a : b));
  const max = valores.reduce((a, b) => (a.valor > b.valor ? a : b));

  return (
    <div style={{ fontSize: '0.9rem', marginTop: '1rem' }}>
      <div><strong>Actual:</strong> {actual.valor} ({actual.hora})</div>
      <div><strong>Mínimo:</strong> {min.valor} <span style={{ color: '#888' }}>({min.hora})</span></div>
      <div><strong>Máximo:</strong> {max.valor} <span style={{ color: '#888' }}>({max.hora})</span></div>
    </div>
  );
}

export default ResumenSensor;
